module.exports = __webpack_public_path__ + "img/kettlebells.f72508df.svg";